import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MessageService } from 'primeng/api';

export function provideToast(): EnvironmentProviders {
    return makeEnvironmentProviders([MessageService]);
}
